export default { sha: '83f294a9ff884dced08a6b4288d987f0f486f65a', buildNumber: 'undefined' }
